export const GET_MACHINES_REQUEST = 'GET_MACHINES_REQUEST';
export const GET_MACHINES_SUCCESS = 'GET_MACHINES_SUCCESS';
export const GET_MACHINES_ERROR = 'GET_MACHINES_ERROR';

export const GET_MACHINE_CLASSIFICATION_REQUEST =
  'GET_MACHINE_CLASSIFICATION_REQUEST';
export const GET_MACHINE_CLASSIFICATION_SUCCESS =
  'GET_MACHINE_CLASSIFICATION_SUCCESS';
export const GET_MACHINE_CLASSIFICATION_ERROR =
  'GET_MACHINE_CLASSIFICATION_ERROR';

export const HIGHLIGHT_STOP = 'HIGHLIGHT_STOP';

export const GET_MACHINES_GROUP_REQUEST = 'GET_MACHINES_GROUP_REQUEST';
export const GET_MACHINES_GROUP_SUCCESS = 'GET_MACHINES_GROUP_SUCCESS';
export const GET_MACHINES_GROUP_ERROR = 'GET_MACHINES_GROUP_ERROR';

export const CREATE_MACHINES_GROUP_REQUEST = 'CREATE_MACHINES_GROUP_REQUEST';
export const CREATE_MACHINES_GROUP_SUCCESS = 'CREATE_MACHINES_GROUP_SUCCESS';
export const CREATE_MACHINES_GROUP_ERROR = 'CREATE_MACHINES_GROUP_ERROR';

export const DELETE_MACHINES_GROUP_REQUEST = 'DELETE_MACHINES_GROUP_REQUEST';
export const DELETE_MACHINES_GROUP_SUCCESS = 'DELETE_MACHINES_GROUP_SUCCESS';
export const DELETE_MACHINES_GROUP_ERROR = 'DELETE_MACHINES_GROUP_ERROR';

export const UPDATE_MACHINES_GROUP_REQUEST = 'UPDATE_MACHINES_GROUP_REQUEST';
export const UPDATE_MACHINES_GROUP_SUCCESS = 'UPDATE_MACHINES_GROUP_SUCCESS';
export const UPDATE_MACHINES_GROUP_ERROR = 'UPDATE_MACHINES_GROUP_ERROR';

export const GET_ASSIGNED_MACHINES_GROUP_FOR_USER_REQUEST =
  'GET_ASSIGNED_MACHINES_GROUP_FOR_USER_REQUEST';
export const GET_ASSIGNED_MACHINES_GROUP_FOR_USER_SUCCESS =
  'GET_ASSIGNED_MACHINES_GROUP_FOR_USER_SUCCESS';
export const GET_ASSIGNED_MACHINES_GROUP_FOR_USER_ERROR =
  'GET_ASSIGNED_MACHINES_GROUP_FOR_USER_ERROR';

export const ADD_MACHINES_GROUP_TO_USER_REQUEST =
  'ADD_MACHINES_GROUP_TO_USER_REQUEST';
export const ADD_MACHINES_GROUP_TO_USER_SUCCESS =
  'ADD_MACHINES_GROUP_TO_USER_SUCCESS';
export const ADD_MACHINES_GROUP_TO_USER_ERROR =
  'ADD_MACHINES_GROUP_TO_USER_ERROR';

export const GET_MACHINE_REAL_TIME_REQUEST = 'GET_MACHINE_REAL_TIME_REQUEST';
export const GET_MACHINE_REAL_TIME_SUCCESS = 'GET_MACHINE_REAL_TIME_SUCCESS';
export const GET_MACHINE_REAL_TIME_ERROR = 'GET_MACHINE_REAL_TIME_ERROR';

export const GET_MACHINE_STATUS_REQUEST = 'GET_MACHINE_STATUS_REQUEST';
export const GET_MACHINE_STATUS_SUCCESS = 'GGET_MACHINE_STATUS_SUCCESS';
export const GET_MACHINE_STATUS_ERROR = 'GET_MACHINE_STATUS_ERROR';
